import { AddFeature, Prefecture } from '@/domain/models/Store';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { StoreManagementStoreService } from '@/services/StoreManagement/AuthStores/StoreManagementStoreService';

export type StoreManagementAuthStoreShowReqponse = {
  id: number;
  name: string;
  email: string;
  phone_number: string;
  prefecture: Prefecture | '';
  city: string | '';
  street_address: string | '';
  building: string | null;
  zip_code: string;
  add_features: AddFeature[];
  latitude: number | null;
  longitude: number | null;
};

export const useStoreManagementAuthStoreShow = async (
  id: number
): Promise<StoreManagementAuthStoreShowReqponse> => {
  const storeManagementStoreService = new StoreManagementStoreService(
    getClient()
  );
  try {
    return await storeManagementStoreService.show(id);
    // return {
    //   id: 2,
    //   name: 'テストストア',
    //   email: 'test1@com',
    //   phone_number: '',
    //   prefecture: '',
    //   city: '',
    //   street_address: '',
    //   building: null,
    //   zip_code: '',
    //   add_features: [
    //     { id: 2, name: 'exec_order_delay' },
    //     { id: 1, name: 'exec_order_prepare' },
    //     { id: 4, name: 'notify_unconfirmed_order' },
    //   ],
    // };
  } catch (error) {
    // @ts-ignore TS2322
    return errorHandler({ error });
  }
};
